import { format } from 'date-fns';

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class ApDateRangeValidator {
    public static validate(minDate: Date, maxDate: Date): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (!value || isNaN(value)) {
                return null;
            }

            const isValid = value >= minDate && value <= maxDate;
            return isValid
                ? null
                : { range: { minDate: format(minDate, 'dd-MM-yyyy'), maxDate: format(maxDate, 'dd-MM-yyyy'), value: control.value } };
        };
    }
}
